import PropTypes from 'prop-types';
import ModalDialog from '@components/ui/ModalDialog.component.jsx';

export default function ErrorModal({
  open = true,
  header,
  description,
  buttonText,
  onButtonClick = () => {},
  onSecondaryButtonClick = null,
  secondaryButtonText = null,
}) {
  return (
    <ModalDialog
      variant={'dark'}
      open={open}
      onClose={onButtonClick}
      onButtonClick={onButtonClick}
      title={header}
      buttonText={buttonText}
      secondaryButtonText={secondaryButtonText}
      onSecondaryButtonClick={onSecondaryButtonClick}
    >
      <p className="text-center text-base py-2 break-words overflow-hidden">
        {description}
      </p>
    </ModalDialog>
  );
}

ErrorModal.propTypes = {
  header: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  onButtonClick: PropTypes.func,
};

ErrorModal.defaultProps = {
  header: 'Error',
  description: 'Error description',
  buttonText: 'Try again',
};
